import { Factory } from 'rosie';

Factory.define('RuleScore');

Factory.define('RuleScoreWithDefaults')
  .attr('id', 'exampleRuleId')
  .attr('name', 'Example Rule Name')
  .attr('revisionId', 3)
  .attr('value', 5);
